










































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';
import TaskProceduresRepository from '@/modules/tasks/procedures/TaskProceduresRepository';
import notificationService from '@/services/notificationService';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
  DxRequiredRule,
} from 'devextreme-vue/form';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxRequiredRule,
  },
})
export default class TaskProcedureCreatePopup extends Vue {
    private showPopup: boolean = false;
    private saving: boolean = false;

    private dto: ITaskProcedureCreateCommand = {
      name: '',
    };

    public show() {
      this.showPopup = true;
    }

    public hide() {
      this.showPopup = false;
    }

    public async save() {
      try {
        this.saving = true;
        const form: any = this.$refs.form;
        const validationResult = form.instance.validate();

        if (validationResult.isValid) {
          const result = await TaskProceduresRepository.create(this.dto);
          notificationService.saved();
          this.$router.push({ path: `/tasks/procedures/${result.data}` });
        } else {
          notificationService.invalidForm();
        }
      } catch (err) {
          notificationService.showAxiosError(err);
      } finally {
        this.saving = false;
      }
    }
}
